import * as React from "react";
import { Box, Typography, Stack, Divider, TableHead, TableRow, TableCell, TableBody, styled, Button, useTheme, } from "@mui/material";
import POBottomTabs from "./POBottomTabs";
import ScrollBox from '../../../components/ScrollBox';
import BackButton from "../../../components/BackButton";
import StyledTableContainer from "../../../components/StyledTableContainer";
import BgBoxOld from "../../../components/BgBoxOld";
import { formatDateWithJs, formatUserType, getPoStatusClrSx, isEmpty, isNotEmpty, makeTxtOverFLow, NumberFormatter, NumFormatter } from "../../../utils/format";
import LabelTxt from "../../../components/LabelTxt";
import { getSinglePo } from "../../../services/po-service";
import { useQuery, useQueryClient } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import route from "../../../utils/Routes";
import constants from "../../../utils/Constants";
import SendAckMdl from "./SendAckMdl";
import { useState } from "react";
import OrderCfmMdl from "./OrderCfmMdl";
import PoNumMdl from "./PoNumMdl";

const PriceText = styled(Typography)({ textAlign: 'right', fontSize: 12, fontWeight: 500 });




function PoInfoPage({ type = 'amtc' }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation()
    const [searchParams] = useSearchParams();
    const { setLoadingScreen, ctxtUser, setNavComValue } = useAuthContext();
    const queryClient = useQueryClient();
    const poIdStrg = searchParams.get("poId");
    const typoHeadStyle = { borderColor: "rgb(0,0,0,0.1)", fontWeight: 500, fontSize: 13, display: "inline-block", width: 160 }
    const typostyle = { fontSize: 12, display: "inline-block" };
    const { isLoading, isError, error, data: poData } = useQuery([QueryKey.poInfo, poIdStrg],
        () => getSinglePo(poIdStrg),
        {
            enabled: isNotEmpty(poIdStrg),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });
    const [ackMdl, setAckMdl] = useState(false);
    const handleAckMdlClose = () => setAckMdl(false);
    const handleAckMdlOpen = () => setAckMdl(true);

    const [cfmMdl, setCfmMdl] = useState(false);
    const handleCfmMdlClose = () => setCfmMdl(false);
    const handleCfmMdlOpen = () => setCfmMdl(true);

    const [poNumMdl, setPoNumMdl] = useState(false);
    const handlePoNumMdlClose = () => setPoNumMdl(false);
    const handlePoNumMdlOpen = () => setPoNumMdl(true);

    const columns = [
        {
            id: 'lineNo',
            label: "S.No",
            align: 'left',
            minWidth: 50,
        },
        {
            id: 'prodName',
            label: "Product",
            align: 'left',
            minWidth: 170
        },
        {
            id: 'amtcProdIdStrg',
            label: "AMTC Ref ID",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'comProdIdStrg',
            label: "Material Code",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'expecDelDate',
            label: "ETD",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'orderedQty',
            label: "Ordered Qty",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'poDeliveredQty',
            label: "Delivered Qty",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'unitPrice',
            label: "Unit Price (OMR)",
            align: 'left',
            minWidth: 100
        },
        {
            id: 'tax',
            label: "Tax (%)",
            align: 'left',
            minWidth: 100,
        },
        {
            id: 'totalPrice',
            label: "Total Price (OMR)",
            align: 'left',
            minWidth: 100,
        }
    ];

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (type === "amtc") {
            setNavComValue({ comId: poData?.comId });
            return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, poData?.comId]);

    function handleRowClick(i) {
        if (type === 'amtc')
            navigate(`${route.aProduct}/?prodId=${i?.amtcProdIdStrg}`);
        else
            navigate(`${route.cProdInfo}/?prodId=${i?.amtcProdIdStrg}`);
    }

    function handleProdReqClick(prodReqIdStrg) {
        if (type === "amtc")
            navigate(`${route.aProdreqinfo}/?prodReqId=${prodReqIdStrg}`)
        else
            navigate(`${route.cProdreqinfo}/?prodReqId=${prodReqIdStrg}`)
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"} >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ width: "100%", mb: 1 }}>
                <Stack width={"30%"}>
                    <BackButton />
                </Stack>
                <Stack width={"40%"} alignItems={"center"}>
                    <Typography style={{ fontSize: 18, fontWeight: 500 }} >Order Request</Typography>
                </Stack>
                <Stack width={"30%"} alignItems={"end"}>
                    {(ctxtUser?.userType === constants.sourcing || ctxtUser?.userType === constants.admin) && <Button onClick={handlePoNumMdlOpen}
                        sx={{ borderRadius: 1, backgroundColor: theme.palette.custom.btn, fontSize: 14, color: "white", py: 0.3 }}
                        variant="contained"  >Update PO Number</Button>}
                </Stack>
            </Stack>
            {poData && <BgBoxOld height={"93%"} py={0.2} px={0.01}>
                <ScrollBox height={"100%"}>
                    <Box height={"100%"} width={"100%"} px={1} position={"relative"}>
                        <Stack direction={"row"} width={"100%"} alignItems={"center"} justifyContent={"space-between"} mt={1}>
                            <Stack direction={"column"} width={"30%"} spacing={1} ml={2}>
                                <Typography sx={{ fontSize: 16, fontWeight: 500 }}>Order Request {poData?.poIdStrg} </Typography>
                                <LabelTxt typoname={"PO Number"} typodetail={poData?.actPoNum ?? "NA"} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                <LabelTxt typoname={"OR Confirmation Date"} typodetail={formatDateWithJs(poData?.orderCfmTime)} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                <Box onClick={() => handleProdReqClick(poData?.prodReqIdStrg)}>
                                    <LabelTxt typoname={"Product Request ID"} typodetail={poData?.prodReqIdStrg} overflow={20} namestyle={typoHeadStyle} detailstyle={{ ...typostyle, fontWeight: 600, cursor: "pointer" }} txtcolor={"rgba(53, 65, 236, 1)"} />
                                </Box>
                                <LabelTxt typoname={"No of Quantity"} typodetail={poData?.totalQty} overflow={20} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                <LabelTxt typoname={"Company"} typodetail={poData?.comName} overflow={40} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                <LabelTxt typoname={"Project Name"} typodetail={`${poData?.projName} (${poData?.actProjIdStrg})`} overflow={30} namestyle={typoHeadStyle} detailstyle={typostyle} />
                                <LabelTxt typoname={"Site Location"} typodetail={poData?.siteLocation} overflow={40} namestyle={typoHeadStyle} detailstyle={typostyle} />
                            </Stack>
                            <Stack width={"60%"} mr={2}>
                                {/* <Box sx={{ p: 2, border: '1px solid rgba(0,0,0,0.2)', borderRadius: 2 }}>
                                    <Stack direction={"row"} justifyContent="space-between" alignItems="center">
                                        <Stack direction={"column"}>
                                            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>Vendor Details</Typography>
                                            <Divider sx={{ mb: 1 }} />
                                            <Typography fontSize={12}>AMTC</Typography>
                                            <Typography fontSize={12}>{makeTxtOverFLow(poData?.vendorLocation, 40)} </Typography>
                                        </Stack>
                                        <Stack direction={"column"} mr={2}>
                                            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>  Customer Details  </Typography>
                                            <Divider sx={{ mb: 1 }} />
                                            <Typography fontSize={12}>{poData?.comName}</Typography>
                                            <Typography fontSize={12}>{makeTxtOverFLow(poData?.delLocation, 40)}</Typography>
                                        </Stack>
                                    </Stack>
                                </Box> */}
                            </Stack>
                        </Stack>

                        <Stack width={"100%"} direction={"row"} justifyContent={"space-between"} mt={2} mb={1.5} alignItems={"center"} px={2}>
                            <Typography fontSize={15} fontWeight="medium">
                                ORDER DETAILS
                            </Typography>
                            {(ctxtUser?.userType === constants.sourcing || ctxtUser?.userType === constants.admin) && <Stack direction={"row"} alignItems={"center"}>
                                {isEmpty(poData?.ackSentTime) && <Button variant="contained" onClick={handleAckMdlOpen} sx={{
                                    height: 30, color: "white", bgcolor: "rgba(34, 161, 68,1)"
                                }}>
                                    Send Acknowledgment
                                </Button>}
                                {(isNotEmpty(poData?.ackSentTime) && isEmpty(poData?.orderCfmTime)) && <Button variant="contained" sx={{
                                    height: 30, color: "white", bgcolor: "rgba(194, 178, 2,1)"
                                }} onClick={handleCfmMdlOpen}>
                                    Send Confirmation
                                </Button>}
                            </Stack>}
                        </Stack>
                        <StyledTableContainer maxHeight={"40%"} isStickyHeader={true}>
                            <TableHead>
                                <TableRow >
                                    {columns.map((column) => (
                                        <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(poData?.prods || []).map((i, index) => {
                                    return (
                                        <React.Fragment key={i?.id}>
                                            <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i)}
                                                sx={{ height: 33, cursor: 'pointer' }} >
                                                {columns.map((column) => {
                                                    const value = i[column.id];
                                                    switch (column.id) {
                                                        case "lineNo":
                                                        case "orderedQty":
                                                        case "poDeliveredQty":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                {NumFormatter(value)}
                                                            </TableCell>
                                                        case "unitPrice":
                                                        case "tax":
                                                        case "totalPrice":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                {NumberFormatter(value)}
                                                            </TableCell>
                                                        case "expecDelDate":
                                                            return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                {formatDateWithJs(value)}
                                                            </TableCell>
                                                        default:
                                                            return (
                                                                <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                                    {(value === null || value === "" || value === "null") ? "-" : value}
                                                                </TableCell>
                                                            );
                                                    }
                                                })}
                                            </TableRow>
                                        </React.Fragment>
                                    );
                                })}
                            </TableBody>
                        </StyledTableContainer>
                        <Stack width={"100%"} direction={"row"} justifyContent={"end"} >
                            <Box sx={{ p: 3, width: 330 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography fontSize={14} fontWeight={500}>Total Unit Price</Typography>
                                    <PriceText>{NumberFormatter(poData?.totalPriceNoTax)} OMR</PriceText>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography fontSize={14} fontWeight={500} marginLeft={5}>Total Tax</Typography>
                                    <PriceText>{NumberFormatter(poData?.totalTax)} OMR</PriceText>
                                </Box>
                                <Divider sx={{ my: 1 }} />
                                <Box sx={{ width: 300, display: 'flex', justifyContent: 'space-between', py: 1, px: 2, bgcolor: 'rgba(253, 240, 213, 0.6)', borderRadius: 1, }}>
                                    <Typography fontSize={14} fontWeight={500} marginLeft={1}>Total Price</Typography>
                                    <PriceText>{NumberFormatter(poData?.totalPriceWithTax)} OMR</PriceText>
                                </Box>
                            </Box>
                        </Stack>
                        <POBottomTabs ackMail={poData?.ackMail} orderCfmMail={poData?.orderCfmMail} dos={poData?.dos} poIdStrg={poData?.poIdStrg} poStatus={poData?.poStatus} />
                        <Stack sx={{
                            bgcolor: getPoStatusClrSx(poData?.poStatus).bycolor, borderRadius: 16, minWidth: 100,
                            position: "absolute", top: 5, right: 10, alignItems: "center", fontSize: 13, py: 0.4, px: 1
                        }}>
                            {formatUserType(poData?.poStatus)}
                        </Stack>
                    </Box>
                </ScrollBox>
                {poData && <SendAckMdl modalOpen={ackMdl} handleModalClose={handleAckMdlClose} poData={poData} />}
                {poData && <OrderCfmMdl modalOpen={cfmMdl} handleModalClose={handleCfmMdlClose} poData={poData} />}
                {poData && <PoNumMdl modalOpen={poNumMdl} handleModalClose={handlePoNumMdlClose} poData={poData} />}
            </BgBoxOld>}
        </Box>
    );
}
export default PoInfoPage;